document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    function initializeModalPopup() {
        var $modalPopup = $('.modalpopup');

        if ($modalPopup.length) {
            $modalPopup.off('click.modalPopup').on('click.modalPopup', function (e) {
                e.preventDefault();
                $(this).hide();

                // expiration 2 days
                var seconds = 60 * 60 * 24 * 2;
                document.cookie = `showpopup2=ok;max-age=${seconds}`;
            });
        }
    }

    initializeModalPopup();
});
